'use client';

import { useEffect } from 'react';

/**
 * Suppresses React DevTools console errors for Next.js 15+ Promise params/searchParams.
 * This is a known compatibility issue where DevTools tries to serialize/enumerate
 * Promise params when hovering over components.
 * 
 * @see https://nextjs.org/docs/messages/sync-dynamic-apis
 */
export function DevToolsErrorSuppressor() {
    useEffect(() => {
        const originalError = console.error;
        
        console.error = (...args: unknown[]) => {
            const message = args[0];
            if (typeof message === 'string') {
                // Suppress DevTools params/searchParams Promise warnings
                if (
                    message.includes('Promise') &&
                    (message.includes('params') || message.includes('searchParams'))
                ) {
                    return;
                }
                // Suppress "params should be unwrapped with React.use()" warnings
                // triggered by Cursor element inspector enumerating params
                if (
                    (message.includes('params') || message.includes('searchParams')) &&
                    message.includes('React.use()')
                ) {
                    return;
                }
                // Suppress "keys of searchParams were accessed directly" warnings
                if (
                    message.includes('searchParams') &&
                    message.includes('accessed directly')
                ) {
                    return;
                }
            }
            originalError.apply(console, args);
        };

        return () => {
            console.error = originalError;
        };
    }, []);

    return null;
}

